import { Box } from '@mui/material'

type TabPanelProps = {
  children: React.ReactNode
  value: number
  index: number
}

/**
 * Tab panel component for organizing content in tabs
 */
export function TabPanel({ children, value, index, ...other }: TabPanelProps) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`stats-tabpanel-${index}`}
      aria-labelledby={`stats-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
    </div>
  )
}
